import { fork } from "redux-saga/effects";
import { CorpSessionInfo, IPerson, SessionInfo } from "redmond";
import { findDeUserForTraveler } from "../../../utils/capone-corporate/travelersMappingUtils";
import { CorpUsersListResponse } from "../user/fetchCorpUsersList";
import { syncPassengerToOtherBusinesses } from "./syncPassengerToOtherBusinesses";

export function* forkTravelerBusinessSync(
  sessionInfo: SessionInfo,
  corpUsersList: CorpUsersListResponse,
  personToUpdate: IPerson
) {
  const currentBusinessId =
    "corporateInfo" in sessionInfo
      ? (sessionInfo as CorpSessionInfo).corporateInfo.businessId
      : undefined;
  const linkedDeUserId = findDeUserForTraveler(
    personToUpdate.id,
    corpUsersList.users
  )?.id;
  if (linkedDeUserId != null && currentBusinessId != null) {
    yield fork(syncPassengerToOtherBusinesses, {
      person: personToUpdate,
      linkedDeUserId,
      currentBusinessId,
    });
  }
}
